// extracted by mini-css-extract-plugin
module.exports = {"container":"RedirectModale_container__2PzmP"};